<template>
    <div class="l-content__block">
        <div class="c-block__headings">
            <h2 id="talent-works">{{talentName}}<br>写真集・週プレ本誌掲載号</h2>
            <div class="c-btn-detail">
                <a :href="route(route_list, 'site.search.index', {'keyword': talentName})">もっと見る</a>
            </div>
        </div>
        <div class="c-filter__group">
            <p class="page-current">全{{allRelationListCount}}件中{{relationList.length}}件</p>
            <div class="is-pc">
                <div class="c-displey-switch">
                <div class="c-displey-switch__list"
                    :class="{ 'is-active': isShow }"
                    @click="isShow = true"
                ><img src="/src/assets/img/common/icon-list.png" alt=""></div>
                <div class="c-displey-switch__tile"
                    :class="{ 'is-active': !isShow }"
                    @click="isShow = false"
                ><img src="/src/assets/img/common/icon-tile.png" alt=""></div>
                </div>
            </div>
        </div>
        <div class="c-thumbnail-list-wrapper" v-if="isShow">
            <ul class="c-thumbnail-list c-thumbnail-list-5">
                <li class="c-thumbnail-list__item c-thumbnail-list__item-5" v-for="(item, index) in relationList" :key=index>
                    <a :href="itemDetailUrl(item)">
                        <div class="c-thumbnail-list__img">
                            <webp-picture :webp="item.thumbnail_webp_file_path">
                                <img loading="lazy" :src="item.thumbnail_file_path" :alt="relationImgAltText(item)">
                            </webp-picture>
                        </div>
                    </a>
                    <div class="c-thumbnail-list__text">
                        <div class="c-thumbnail-list__text-top">
                            <div class="c-thumbnail-list__icon">
                                <div class="c-label is-new" v-if="item.is_new === true">New</div>
                                <div class="c-label is-photos">{{item.category_label}}</div>
                                <div class=" c-label is-limited" v-if="item.has_extra_item === 1">限定特典付</div>
                            </div>
                        </div>
                        <p class="c-thumbnail-list__booktitle">
                            <a :href="itemDetailUrl(item)">
                                <h3 class="c-thumbnail-list__booktitle-heading">{{item.name}}</h3>
                            </a>
                        </p>
                        <div v-if="item.CATEGORY_CD !== 'WPB'">
                            <p class="c-thumbnail-list__bookname" v-for="(talent, i) in item.talents" :key="`first-${i}`">
                                <a :href="route(route_list, 'site.talent.detail', {model_id:talent.id, model_name:talent.name})">{{ talent.name }}</a>
                            </p>
                        </div>
                        <p v-if="item.discount_price_tax !== '0'" class="c-thumbnail-list__price">
                            <span class="u-bold">￥{{ item.discount_price_tax }}</span>（税込）
                            <span class="c-label-off">{{ item.discount_string }} OFF</span>
                        </p>
                        <p v-else class="c-thumbnail-list__price c-black">
                            <span class="u-bold">￥{{ item.item_price_tax }}</span>（税込）
                        </p>
                        <p class="c-thumbnail-list__lead">{{ item.description }}</p>
                        <p class="c-thumbnail-list__publish-date">発売日：{{ getDspStartDate(item) }}</p>
                        <p class="c-thumbnail-list__publisher" v-for="(creater, i) in item.creaters" :key="`second-${i}`">出版社：{{ creater.category_name }}</p>
                        <p class="c-thumbnail-list__series" v-if="item.series_name != null">シリーズ名：{{ item.series_name }}</p>
                        <div v-if="item.CATEGORY_CD !== 'WPB'">
                            <p class="c-thumbnail-list__model" v-for="(talent, i) in item.talents" :key="`third-${i}`">モデル：<a :href="route(route_list, 'site.talent.detail', {model_id:talent.id, model_name:talent.name})">{{ talent.name }}</a></p>
                        </div>
                        <p class="c-thumbnail-list__photograph" v-for="(creater, i) in item.creaters" :key="`fourth-${i}`">撮影：<a :href=creater.url>{{ creater.name }}</a></p>
                        <p class="c-thumbnail-list__page" v-if="item.page_num != null">ページ数：{{ item.page_num }}P</p>
                        <template v-if="purchasedItem[item.T_M_ITEM_ID]">
                            <div v-if="item.PAID_BROWSER_VIEW_PARAM" class="c-btn-read2 browser_btn">
                                <a target="_blank" :href="route(route_list, 'site.item.viewer', {item_detail_url:item.ITEM_DETAIL_URL})">ブラウザで見る</a>
                            </div>
                            <div v-if="item.PAID_BROWSER_VIEW_PARAM" class="c-btn-read2">
                                <a class="js-book-read-button" href="javascript:void(0)" :data-bookid="purchasedItem[item.T_M_ITEM_ID]">アプリで見る</a>
                            </div>
                            <div v-else class="c-btn-read2 app-btn-only">
                                <a class="js-book-read-button" href="javascript:void(0)" :data-bookid="purchasedItem[item.T_M_ITEM_ID]">アプリで見る</a>
                            </div>
                        </template>
                        <template v-else>
                            <div v-if="item.BROWSER_VIEW_PARAM" class="c-btn-trial">
                                <a target="_blank" :href="route(route_list, 'site.item.sample', {item_detail_url:item.ITEM_DETAIL_URL})">立ち読み</a>
                            </div>
                        </template>
                    </div>
                </li>
            </ul>
        </div>
        <!-- c-thumbnail-list-wrapper -->
        <div class="c-thumbnail-list-wrapper" v-else>
            <ul class="c-thumbnail-list c-thumbnail-list-4">
                <li class="c-thumbnail-list__item c-thumbnail-list__item-4" v-for="(item, index) in relationList" :key=index>
                    <a :href="itemDetailUrl(item)">
                        <div class="c-thumbnail-list__img">
                            <webp-picture :webp="item.thumbnail_webp_file_path" class="inherit">
                                <img loading="lazy" :src="item.thumbnail_file_path" :alt="relationImgAltText(item)">
                            </webp-picture>
                        </div>
                        <div class="c-thumbnail-list__text">
                            <p class="c-bookname" v-for="(talent, i) in item.talents" :key="`first-${i}`">{{ talent.name }}</p>
                            <p class="c-booktitle text-truncate2">{{ $filters.truncate(item.name, 21, "...") }}</p>
                            <p v-if="item.discount_price_tax !== '0'" class="c-thumbnail-list__price">
                                <span class="u-bold">￥{{ item.discount_price_tax }}</span>（税込）
                                <span class="c-label-off">{{ item.discount_string }} OFF</span>
                            </p>
                            <p v-else class="c-thumbnail-list__price c-black"><span class="u-bold">￥{{ item.item_price_tax }}</span>（税込）</p>
                            <div class="c-thumbnail-list__icon">
                                <div class="c-label is-new" v-if="item.is_new === true">New</div>
                                <div class="c-label is-photos">{{item.category_label}}</div>
                                <div class=" c-label is-limited" v-if="item.has_extra_item === 1">限定特典付</div>
                            </div>
                        </div>
                    </a>
                    <template v-if="purchasedItem[item.T_M_ITEM_ID]">
                        <div v-if="item.PAID_BROWSER_VIEW_PARAM" class="c-btn-read-min">
                            <a target="_blank" :href="route(route_list, 'site.item.viewer', {item_detail_url:item.ITEM_DETAIL_URL})">ブラウザ<br>で見る</a>
                        </div>
                        <div v-if="item.PAID_BROWSER_VIEW_PARAM" class="c-btn-read-min">
                            <a class="js-book-read-button" href="javascript:void(0)" :data-bookid="purchasedItem[item.T_M_ITEM_ID]">アプリ<br>で見る</a>
                        </div>
                        <div v-else class="c-btn-read-min app-btn-only">
                            <a class="js-book-read-button" href="javascript:void(0)" :data-bookid="purchasedItem[item.T_M_ITEM_ID]">アプリで見る</a>
                        </div>
                    </template>
                    <template v-else>
                        <div v-if="item.BROWSER_VIEW_PARAM" class="c-btn-trial">
                            <a target="_blank" :href="route(route_list, 'site.item.sample', {item_detail_url:item.ITEM_DETAIL_URL})">立ち読み</a>
                        </div>
                    </template>
                </li>
            </ul>
        </div>
        <!-- c-thumbnail-list-wrapper -->
        <div class="c-btn-detail">
            <a :href="route(route_list, 'site.search.index', {'keyword': talentName})">もっと見る</a>
        </div>
    </div>
    <!-- l-content__block -->
</template>

<script>
import axios from 'axios';
import routeMixin from '../../mixins/route.js';
import moment from 'moment';

export default {
    props: {
        relationList: { type: Array, required: true },
        allRelationListCount: { type: Number, required: true },
        talentName: { type: String, required: true },
        route_list: { type: Object, required: true },
        is_plus: Boolean,
        rate_for_plus: Number,
        purchasedItem: Object,
    },
    mixins: [routeMixin],
    data () {
        return {
            isShow: true,
            liked:false,
        }
    },
    computed: {
        windowWidth() {
            return this.getWindowWidth();
        },
        moment() {
            return moment;
        }
    },
    mounted(){
        this.$nextTick(() => {
            window.addEventListener('resize', this.getWindowWidth());
        })
    },
    methods:{
        getWindowWidth(event) {
            let breakpoint = document.documentElement.clientWidth;
            if(breakpoint < 767){
                this.isShow = true;
            }
        },
        selectChange(){
            let select = event.target;
            let input = select.closest('div').getElementsByTagName('input')[0];
            setTimeout(function(){ input.value = select.options[0].text }, 200);
        },
        resetInputChange(){
            let input = event.target;
            let select = input.nextElementSibling.closest('div').getElementsByTagName('select')[0];
            setTimeout(function(){ input.value = select.options[0].text }, 200);
        },
        itemDetailUrl(item) {
            if (item.CATEGORY_CD=='GRV') {
                return this.route(this.route_list, 'site.item.detail.gravure', {'item_detail_url': item.ITEM_DETAIL_URL});
            }
            if (item.CATEGORY_CD=='WPB') {
                return this.route(this.route_list, 'site.weeklyplayboy', {'item_detail_url': item.ITEM_DETAIL_URL});
            }
            return this.route(this.route_list, 'site.item.detail.gravure', {'item_detail_url': item.ITEM_DETAIL_URL});
        },
        getDspStartDate(item) {
            if (!item.sale_start_date && !item.DSP_START_DATE) {
                return '';
            }
            return this.moment(item.sale_start_date || item.DSP_START_DATE).format('YYYY/MM/DD');
        },
        relationImgAltText(relationListItem) {
            if(relationListItem.CATEGORY_CD=='GRV') {
                return this.talentName + 'グラビア' + '_' + relationListItem.biliographic_textinfo.DOCUMENT_TITLE;
            }
            if(relationListItem.CATEGORY_CD=='WPB') {
                return this.talentName + '_' + relationListItem.biliographic_textinfo.DOCUMENT_TITLE;
            }
            return '';
        }
    },
}
</script>

<style lang="scss" scoped>
.c-thumbnail-list__booktitle {
    word-break: break-all;
}

.c-thumbnail-list__booktitle-heading {
    font-size: inherit;
    letter-spacing: inherit;
    line-height: inherit;
    text-align: inherit;
}
</style>
